import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";import {Add as AddIcon} from '@mui/icons-material'
import {Link} from 'react-router-dom'
import {cn} from '../../ui/cn'

import {ActivityCard} from './ActivityCard'
import { CATEGORY_ID_TO_NAME, CATEGORY_THEMES} from './Categories'






const CreateActivityCard = (props) => {
  const {category, className} = props

  return (
    _jsx(Link, {
      className: cn('flex rounded-2xl hover:bg-slate-100 focus:outline-sky-500', className),
      to: `/activity-library/new-activity/${category}`,
 children: 
      _jsx(ActivityCard, { className: 'flex-1 cursor-pointer', theme: CATEGORY_THEMES[category], children: 
        _jsxs('div', { className: "flex h-full w-full flex-col items-center justify-center pb-2 font-semibold"       , children: [
          _jsx('div', { className: "h-12 w-12" , children: 
            _jsx(AddIcon, { className: "h-full w-full text-slate-700"  ,} )
          }), "Create Custom "
            , category !== 'recommended' ? CATEGORY_ID_TO_NAME[category] : '', " Activity"
        ]})
      })
    })
  )
}

export default CreateActivityCard
